<template>
  <div class="MonthlyIOReport">
    <box :title="$t('search')">
      <div>
        <monthly-date-picker @getDate="getDate" />
      </div>
    </box>

    <box :title="$t('IntervalIOReportList')" class="mt-2">
      <div v-if="list.length > 0">
        <v-alert
          class="ma-2"
          text
          dense
          color="primary lighten-1"
          icon="mdi-comment-alert-outline"
          border="left"
        >
          با کلیک راست کردن روی هر سطر می توانید عملیات ثبت مرخصی، ماموریت،ورود
          و خروج و اضافه کار را انجام دهید
        </v-alert>
        <IntervalIOReportListWeb :list="list" class="hidden-sm-and-down" />
        <IntervalIOReportListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import IntervalIOReportListMob from "../../components/io/IntervalIOReport/IntervalIOReportListMob.vue";
import IntervalIOReportListWeb from "../../components/io/IntervalIOReport/IntervalIOReportListWeb.vue";
import MonthlyDatePicker from "../../components/widget/MonthlyDatePicker.vue";
export default {
  components: {
    IntervalIOReportListWeb,
    IntervalIOReportListMob,
    MonthlyDatePicker,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    getDate(year, month) {
      this.GetPeriodBeginAndEndDate(year, month);
    },
    GetPeriodBeginAndEndDate(year, month) {
      const params = new URLSearchParams();
      params.append("periodNumber", month);
      params.append("year", year);

      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];
              this.GetPersonMergeIo(data.BeginDate, data.EndDate);
            }
          }
        });
    },
    GetPersonMergeIo(BeginDate, endDate) {
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", endDate);
      var perno = this.$store.state.personel.personelDetail.Perno;
      params.append("perno", perno);

      this.$store.dispatch("GetPersonMergeIo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          this.list = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>